import { Col, Row } from 'react-bootstrap';

import { StringInput, MaskInput, DateTimeInput } from 'modules/core/components/forms';
import { dateUtils } from 'modules/core/utils';

const ClientDocs = () => (
  <Col md={ 12 }>
    <Row>
      <Col md={ 12 }>
        Паспорт
        <Row>
          <Col md={ 4 }>
            <StringInput
              name='passportSeries'
              label='Серия'
              placeholder='Серия'
              disabled
            />
          </Col>
          <Col md={ 4 }>
            <StringInput
              name='passportNumber'
              label='Номер'
              placeholder='Номер'
              disabled
            />
          </Col>
          <Col md={ 4 }>
            <DateTimeInput
              name='passportIssuedDate'
              label='Дата выдачи'
              placeholder='Дата выдачи'
              minDate={ dateUtils.yearsAgo(100) }
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col md={ 6 }>
            <StringInput
              name='passportIssued'
              label='Кем выдан'
              placeholder='Кем выдан'
              disabled
            />
          </Col>
          <Col md={ 6 }>
            <StringInput
              name='passportIssuedCode'
              label='Код подразделения'
              placeholder='Код подразделения'
              disabled
            />
          </Col>
        </Row>
      </Col>
      <Col md={ 12 }>
        <Row>
          <Col md={ 6 }>
            <MaskInput
              name='snils'
              label='Снилс'
              placeholder='Номер'
              maskPattern='000-000-000-00'
              disabled
            />
          </Col>
          <Col md={ 6 }>
            <StringInput
              name='drivingLicense'
              label='Водительское удостоверение'
              placeholder='Серия и номер'
              disabled
            />
          </Col>
        </Row>
      </Col>
    </Row>
  </Col>
);

export default ClientDocs;
